import React from "react";
import {
  FilledButton2,
  InputContainer,
  TextLabel,
  TransactionHashContainer,
  TransactionHashSection,
} from "./style";
import FormCard from "../../../reusables/cards/FormCard";
import { RiShareBoxLine } from "react-icons/ri";

const SuccessCard = ({ setActiveStep }) => {
  return (
    <FormCard>
      <InputContainer>
        <img
          src="/assets/img/SVG/green-check.svg"
          alt="green-check"
          style={{ width: "150px" }}
        />
        <TextLabel>Pool Payment</TextLabel>
        <TextLabel>Created Successfully!</TextLabel>
        <TransactionHashSection>
          <TextLabel>Transaction Hash:</TextLabel>
          <TransactionHashContainer>
            <span>0x82a0e6c02b91ec9f6ff94......</span>
            <RiShareBoxLine />
          </TransactionHashContainer>
          <FilledButton2 onClick={() => setActiveStep(0)}>
            Create another pool
          </FilledButton2>
        </TransactionHashSection>
      </InputContainer>
    </FormCard>
  );
};

export default SuccessCard;
